import { apiURL } from "../../config";

export async function getDecisionPreview(axiosPrivate, decisionID) {
	return axiosPrivate
		.get(`${apiURL}/decision/receiver/${decisionID}/extract.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}
